import "core-js/modules/es.array.push.js";
import { setImgsize } from '@/utils/utils';
export default {
  name: 'audioItemv2',
  data() {
    return {
      isPlaying: false,
      //播放按钮开关
      currentIndex: 0,
      //目前在播放的audio
      audioPath: '',
      prevIndex: 0,
      //上次播放实例
      process: 0 //音频进度
    };
  },
  props: ['audioList', 'formData', 'language', 'audioType'],
  methods: {
    clickPlay(index, item) {
      if (this.currentIndex != index) this.audioPath = '';
      if (this.isPlaying && this.currentIndex === index) {
        this.stopAudio(index);
      } else {
        this.$emit('play-audio');
        this.playAudio(index);
      }
    },
    getAudioDetail(item) {
      let query = this.$route.query;
      query.location = item.exhibitionLocation;
      delete query.exhibCode;
      // alert(item.code)
      this.$router.push({
        path: `/audioDetailv2/${item.code}`,
        query
      });
    },
    stopAudio(index) {
      this.$refs.audioItem.pause();
      this.currentIndex = index;
      this.isPlaying = false;
    },
    stopCurrentAudio() {
      if (this.isPlaying && this.$refs.audioItem) {
        this.$refs.audioItem.pause();
        this.isPlaying = false;
      }
    },
    playAudio(index) {
      index === this.prevIndex ? console.log('继续播放') : this.process = 0;
      this.setAudioPath(this.audioList[index].audioPath, index);
    },
    setAudioPath(audioPath, index) {
      if (!audioPath) return;
      this.$api.getUrlByObjectId(audioPath).then(res => {
        this.audioPath = res.http;
        this.$nextTick(() => {
          this.$refs.audioItem.play();
        });
        this.currentIndex = index;
        this.prevIndex = index;
        this.isPlaying = true;
      });
    },
    getImg(data, width, height) {
      return data.fileUrl;
    }
  },
  created() {},
  computed: {}
};